// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { setNestedInReduxState } from 'redux/helpers'
import initialState from './initialState'

import {
  SET_BULK_REMINDER_SUMMARY_EMAIL,
  SET_FILING_STATUS_DATA,
  SET_PCN_DATA,
  SET_PCN_RENEWAL_DATA,
  SET_PCN_RENEWAL_HIGHLIGHTED_IDS,
  SET_RENEWAL_ADMIN_DATA,
  SET_RENEWAL_ADMIN_HIGHLIGHTED_IDS,
  SET_WORK_ORDERS_DATA,
} from './types'

const projectTracker = (state = initialState, action) => {
  switch (action.type) {
    case SET_WORK_ORDERS_DATA :
      return setNestedInReduxState(
        state,
        'workOrders',
        {
          ...state.workOrders,
          data: action.data,
          dataExpiration: action.dataExpiration,
        }
      )

    case SET_PCN_DATA :
      return setNestedInReduxState(
        state,
        'pcn',
        {
          ...state.pcn,
          data: action.data,
          dataExpiration: action.dataExpiration,
        }
      )

    case SET_PCN_RENEWAL_DATA :
      return setNestedInReduxState(
        state,
        'pcnRenewal',
        {
          ...state.pcnRenewal,
          data: action.data,
          dataExpiration: action.dataExpiration,
        }
      )

    case SET_RENEWAL_ADMIN_DATA :
      return setNestedInReduxState(
        state,
        'renewalAdmin',
        {
          ...state.renewalAdmin,
          data: action.data,
          dataExpiration: action.dataExpiration,
        }
      )

    case SET_PCN_RENEWAL_HIGHLIGHTED_IDS :
      return setNestedInReduxState(
        state,
        'pcnRenewal',
        {
          ...state.pcnRenewal,
          ...action.newHighlightData,
        }
      )

    case SET_BULK_REMINDER_SUMMARY_EMAIL:
      return setNestedInReduxState(
        state,
        'pcnRenewal',
        {
          ...state.pcnRenewal,
          bulkReminderSummaryEmailData: action.bulkReminderSummaryEmailData,
        }
      )

    case SET_RENEWAL_ADMIN_HIGHLIGHTED_IDS :
      return setNestedInReduxState(
        state,
        'renewalAdmin',
        {
          ...state.renewalAdmin,
          ...action.newHighlightData,
        }
      )

    case SET_FILING_STATUS_DATA :
      return setNestedInReduxState(
        state,
        'filingStatus',
        {
          ...state.filingStatus,
          data: action.data,
          dataExpiration: action.dataExpiration,
        }
      )

    default :
      return state
  }
}

export default projectTracker
